import { render, staticRenderFns } from "./ProductCardDisplay.vue?vue&type=template&id=19824dfa&scoped=true"
import script from "./ProductCardDisplay.vue?vue&type=script&lang=js"
export * from "./ProductCardDisplay.vue?vue&type=script&lang=js"
import style0 from "./ProductCardDisplay.vue?vue&type=style&index=0&id=19824dfa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19824dfa",
  null
  
)

export default component.exports